"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootDistrictSagas = void 0;
var effects_1 = require("redux-saga/effects");
var PlaceSaga_1 = require("@/pages/place/sagas/PlaceSaga");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var PlaceFollowedApiSaga_1 = require("@/pages/place/sagas/api/PlaceFollowedApiSaga");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var SaveSearchSet_1 = require("@/pages/common/states/SaveSearchSet");
var getDistrictId = function (state) { return state.place.id; };
var getDistrictBuyRentType = function (state) { return state.place.type; };
var getStateCallback = function () {
    var state, districtId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select()];
            case 1:
                state = _a.sent();
                districtId = state.place.id;
                state.hfilter.listingType = SfilterTypeGroup_1.SfilterType.toListingPurposeType(state.place.type);
                state.hfilter.districts = state.hfilter.districts.map(function (it) { return (it.id !== districtId) ? it : (__assign(__assign({}, it), { selected: true })); });
                return [2 /*return*/, state];
        }
    });
};
var getNameCallback = function () {
    var state;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select()];
            case 1:
                state = _a.sent();
                return [2 /*return*/, state.place.nameMain];
        }
    });
};
var checkDistrictFollowState = function () {
    var districtId, lang, type, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getDistrictId)];
            case 1:
                districtId = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(getDistrictBuyRentType)];
            case 3:
                type = _a.sent();
                return [4 /*yield*/, effects_1.call(PlaceFollowedApiSaga_1.checkDistrictFollowedApi, districtId, type, lang)];
            case 4:
                response = _a.sent();
                if (response && response.data && response.data.userSearchSetId) {
                    return [2 /*return*/, response.data.userSearchSetId];
                }
                return [2 /*return*/];
        }
    });
};
var transformSearchQuery = function (searchQuery) {
    return __generator(this, function (_a) {
        searchQuery.searchSaveSetType = SaveSearchSet_1.SearchSaveSetType.District;
        return [2 /*return*/, searchQuery];
    });
};
var watchOnsaveClickDistrictSaga = PlaceSaga_1.watchOnSaveClickSaga(getStateCallback, getNameCallback, transformSearchQuery);
var watchSetUserAndSetFollowDistrictState = PlaceSaga_1.watchSetUserAndSetFollowState(checkDistrictFollowState);
var rootDistrictSagas = {
    rootPlaceSagas: PlaceSaga_1.rootPlaceSagas,
    watchOnsaveClickDistrictSaga: watchOnsaveClickDistrictSaga,
    watchSetUserAndSetFollowDistrictState: watchSetUserAndSetFollowDistrictState,
};
exports.rootDistrictSagas = rootDistrictSagas;
